<template>
  <div>
    <h2 v-if="isGBWill">What is your marital status?</h2>
    <h2 v-else>Are you married or do you have a life partner?</h2>
    <ValidationObserver ref="observer">
      <v-form @submit.prevent="submit">
        <ValidationProvider
          id="marital_status"
          v-slot="{ errors }"
          name="marital_status"
          rules="required"
        >
          <RadioSelect
            v-if="isGBWill"
            v-model="maritalStatus"
            :items="[
              { value: 'MARRIED', text: 'Married' },
              { value: 'SINGLE', text: 'Single' },
              {
                value: 'LIVING_BUT_NOT_MARRIED',
                text: 'Living with a partner but not married',
              },
              { value: 'CIVIL_PARTNERSHIP', text: 'Civil Partnership' },
              { value: 'ENGAGED', text: 'Engaged' },
              { value: 'WIDOWED', text: 'Widowed' },
              {
                value: 'WIDOWED_AND_REMARRIED',
                text: 'Widowed and remarried',
              },
              {
                value: 'MARRIED_BUT_SEPARATED',
                text: 'Married but separated',
              },
              {
                value: 'CIVIL_PARTNERSHIP_BUT_SEPARATED',
                text: 'Civil partnership but separated',
              },
              { value: 'DIVORCED', text: 'Divorced' },
            ]"
            :color="'white'"
            :errors="errors"
            :group="'marital_status'"
          />
          <RadioSelect
            v-else
            v-model="maritalStatus"
            :items="[
              { value: 'MARRIED', text: 'Yes' },
              { value: 'NOT_MARRIED', text: 'No' },
            ]"
            :color="'white'"
            :errors="errors"
            :group="'marital_status'"
          />
        </ValidationProvider>

        <div class="button-container">
          <DefaultButton
            @defaultButtonClicked="redirectBack"
            :callout="'left'"
            :small="true"
          />
          <GradientButton
            :title="'Next'"
            :small="true"
            :type="'submit'"
            :callout="'right'"
            :loading="buttonLoading"
          />
        </div>
      </v-form>
    </ValidationObserver>
    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import { UPDATE_TESTATOR_MUTATION } from '../../constants/graphql/testators';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'AreYouMarried',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        maritalStatus: this.testator.maritalStatus,
        wizard: this.$route.query.peopleWizard,
      };
    },
    computed: {
      isGBWill() {
        return this.testator.willCountry == 'GB';
      },
      needSpouseDetails() {
        return [
          'MARRIED',
          'CIVIL_PARTNERSHIP',
          'ENGAGED',
          'WIDOWED_AND_REMARRIED',
          'MARRIED_BUT_SEPARATED',
          'CIVIL_PARTNERSHIP_BUT_SEPARATED',
          'LIVING_BUT_NOT_MARRIED',
        ].includes(this.maritalStatus);
      },
    },
    methods: {
      submit() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.updateTestator();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      updateTestator() {
        const testatorInputDetails = {
          maritalStatus: this.maritalStatus,
        };
        const id = this.testator.id;
        this.$apollo
          .mutate({
            mutation: UPDATE_TESTATOR_MUTATION,
            variables: {
              id,
              testatorInputDetails,
            },
          })
          .then(_response => {
            this.redirectToNext();
            this.buttonLoading = false;
            if (!this.wizard) this.$emit('refetchQuery');
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      redirectToNext() {
        if (this.needSpouseDetails) {
          this.$router.push('spouse');
        } else {
          if (this.wizard == 'spouse') {
            this.$router.push({ name: 'PeopleOverview', hash: '#spouse' });
          } else {
            this.$router.push('children');
          }
        }
      },
      redirectBack() {
        this.$router.push({ name: 'PeopleOverview' });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .button-container {
    display: flex;
    gap: 20px;
  }
</style>
